var React = require('react');

function IconDevices (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M4 6h18V4H4a2.006 2.006 0 0 0-2 2v11H0v3h14v-3H4zm19 2h-6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1zm-1 9h-4v-7h4z","transform":"translate(0 -4)"}));
}

IconDevices.defaultProps = {"width":"24","height":"16","viewBox":"0 0 24 16"};

module.exports = IconDevices;

IconDevices.default = IconDevices;
